import moment from 'moment'
import {
  CAMPOS_DA_CONFIG_POR_TIPO_DE_FILTRO,
  BUCKET_IMPORTADOR_DE_ESCALAS_TEMPORARIAS,
  ENTIDADE_PARA_BACKEND,
  EXTENSOES_DO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS,
  NOME_DA_ABA_CSV_DO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS,
  ORIGENS_DA_SELECAO_DA_ESCALA_TEMPORARIA,
  TIPO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS,
  TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA
} from './constantes'

export const DIAS_MINIMOS_ENTRE_DATAS_DA_ESCALA_TEMPORARIA = 0

export function obterDataFinalMinimaDaEscalaTemporaria (dataInicial) {
  if (!dataInicial) { return null }

  return moment(dataInicial)
    .add(DIAS_MINIMOS_ENTRE_DATAS_DA_ESCALA_TEMPORARIA, 'days')
    .toDate()
}

export function periodoTemDuracaoMinima (dataInicial, dataFinal) {
  if (!dataInicial || !dataFinal) { return false }

  return !moment(dataFinal).isBefore(obterDataFinalMinimaDaEscalaTemporaria(dataInicial), 'day')
}

export function possuiEmpregadosSelecionados (empregados) {
  return Boolean(empregados && empregados.selected && empregados.selected.length)
}

export function possuiEntidadesSelecionadas (configAtual) {
  if (configAtual.origemSelecao === ORIGENS_DA_SELECAO_DA_ESCALA_TEMPORARIA.PLANILHA) {
    return arquivoEhPlanilhaValida(configAtual.arquivoSelecao)
  }

  const selecoes = {
    [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.EMPREGADOS]: configAtual.empregados,
    [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.LOCAIS_DE_TRABALHO]: configAtual.locaisDeTrabalho,
    [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.EMPREGADORES]: configAtual.empregadores
  }

  return possuiEmpregadosSelecionados(selecoes[configAtual.tipoFiltro])
}

export function arquivoEhPlanilhaValida (arquivo) {
  if (!arquivo || !arquivo.name) { return false }

  const extensao = obterExtensaoDoArquivo(arquivo.name)
  return EXTENSOES_DO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS.includes(extensao)
}

export function obterExtensaoDoArquivo (nomeDoArquivo = '') {
  const partes = nomeDoArquivo.toLowerCase().split('.')
  return partes.length > 1 ? partes.pop() : ''
}

export function gerarNomeDoArquivoDaImportacaoDeEscalasTemporarias ({
  arquivo,
  empresaId,
  usuarioId,
  dataAtual = new Date()
}) {
  const extensao = obterExtensaoDoArquivo(arquivo?.name)
  const dataFormatada = dataAtual.toISOString().replace(/\.\d{3}Z$/, '').replace(/:/g, '-')
  const identificadorDoArquivo = `${empresaId}-${usuarioId}-${dataFormatada}`
    .replace(/[^a-zA-Z0-9-.]/g, '-')
  const prefixoDoArquivo = extensao === 'csv'
    ? NOME_DA_ABA_CSV_DO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS
    : 'escala-temporaria'

  return `${prefixoDoArquivo}-${identificadorDoArquivo}.${extensao}`
}

export function montarPayloadDoImportadorDeEscalasTemporarias (
  caminhoDoArquivoNoBucket,
  bucket = BUCKET_IMPORTADOR_DE_ESCALAS_TEMPORARIAS
) {
  return {
    bucket,
    caminho_do_arquivo_no_bucket: caminhoDoArquivoNoBucket,
    tipo_de_importador: TIPO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS
  }
}

export function possuiConfigParaAbrirCalendario (configAtual) {
  return Boolean(configAtual.escala)
}

export function configAtualEstaValida (configAtual) {
  return Boolean(
    possuiEntidadesSelecionadas(configAtual) &&
    configAtual.dataInicial &&
    configAtual.dataFinal &&
    configAtual.escala &&
    periodoTemDuracaoMinima(configAtual.dataInicial, configAtual.dataFinal) &&
    configAtual.faseInicialSelecionada
  )
}

export function listarErrosDaConfigAtual (configAtual, mensagens) {
  const erros = []

  if (!possuiEntidadesSelecionadas(configAtual)) {
    erros.push(configAtual.origemSelecao === ORIGENS_DA_SELECAO_DA_ESCALA_TEMPORARIA.PLANILHA
      ? mensagens.planilha
      : mensagens.selecao)
  }

  if (!configAtual.dataInicial || !configAtual.dataFinal) {
    erros.push(mensagens.periodo)
  } else if (!periodoTemDuracaoMinima(configAtual.dataInicial, configAtual.dataFinal)) {
    erros.push(mensagens.periodoMinimo)
  }

  if (!configAtual.escala) {
    erros.push(mensagens.escala)
  }

  if (!configAtual.faseInicialSelecionada) {
    erros.push(mensagens.faseInicial)
  }

  return erros.filter(Boolean)
}

// Body do POST /calendario-de-trabalho/escala-temporaria/criacao-em-massa (flat camelCase — CamelModel).
export function montarPayloadDaConfigAtual (configAtual) {
  const selecao = obterSelecaoDaConfigAtual(configAtual)

  return {
    idEscalaTemporaria: configAtual.escala ? configAtual.escala.id : null,
    inicio: configAtual.dataInicial ? moment(configAtual.dataInicial).format('YYYY-MM-DD') : null,
    fim: configAtual.dataFinal ? moment(configAtual.dataFinal).format('YYYY-MM-DD') : null,
    entidade: ENTIDADE_PARA_BACKEND[configAtual.tipoFiltro],
    ids: selecao.selected.map(item => item.id),
    fase: configAtual.deslocamentoDaJornada,
    faseNaRestauracao: null,
    gerarParaTodos: false
    // `considerarDemitidos` omitido → backend usa o default `TODOS`.
  }
}

function obterSelecaoDaConfigAtual (configAtual) {
  return configAtual[CAMPOS_DA_CONFIG_POR_TIPO_DE_FILTRO[configAtual.tipoFiltro]] || { selected: [] }
}

// Id do relatório do framework (GerarRelatorio) devolvido pela criação em massa.
export function obterIdDoRelatorio (resposta = {}) {
  const corpo = resposta.body || resposta.data || resposta || {}
  return corpo.relatorio || null
}

// POST /api/escala-temporaria/{id}/cancelar responde 200 (cancelada direto) ou 202
// (abriu solicitação de cancelamento, efetivada só na aprovação). Quem decide é o
// GerenciadorDeSolicitacoes no backend — RH ou empresa sem regra cancela na hora —,
// então o status é a única fonte confiável; o perfil do usuário não basta.
export function criouSolicitacaoDeCancelamento (resposta = {}) {
  return resposta?.status === 202
}

// Erro de negócio no novo contrato FastAPI: { detail, codigo, description? }.
// `detail` também é string em 403; em 422 (validação) vem como array e é ignorado.
// Mantém compatibilidade com o contrato antigo (Flask): { error, description }.
export function obterMensagemDeErroDaApi (erro, mensagemPadrao = '') {
  const corpos = [erro?.response?.data, erro?.data, erro?.body].filter(Boolean)

  for (const corpo of corpos) {
    if (corpo.description) { return corpo.description }
    if (typeof corpo.detail === 'string') { return corpo.detail }
    if (corpo.error) { return corpo.error }
  }

  return erro?.message || mensagemPadrao
}

// Resposta de POST /api/escala-temporaria/historico:
// { totalDeItens, totalDePaginas, resultado: [RespostaEscalaTemporariaHistorico] }
export function normalizarHistorico (resposta = {}) {
  const corpo = resposta.body || resposta.data || resposta || {}
  const resultado = Array.isArray(corpo.resultado) ? corpo.resultado : []

  return {
    itens: resultado.map(normalizarItemHistorico),
    paginacao: {
      total: corpo.totalDeItens ?? resultado.length,
      totalDePaginas: corpo.totalDePaginas ?? 1
    }
  }
}

// Achata um item do histórico para o modelo consumido pela tabela/detalhes.
// Campos opcionais do contrato chegam como `null` quando o dado não existe e a UI
// mostra `-`. `possuiFolhaTravada` é o único campo lido aqui que o backend ainda não
// devolve (degrada para `false`, escondendo o alerta de folha travada).
export function normalizarItemHistorico (item = {}) {
  const empregado = item.empregado || {}
  const intervalo = item.intervalo || {}

  return {
    id: item.id,
    empregadoId: empregado.id,
    nomeDoEmpregado: empregado.nome,
    dataInicialEscala: intervalo.inicio,
    dataFinalEscala: intervalo.fim,
    idEscalaTemporaria: item.idEscalaTemporaria,
    statusDaSolicitacao: item.statusDaSolicitacao,
    geradaPorSolicitacao: item.geradaPorSolicitacao,
    auditoria: item.auditoria || null,
    codigoDoEmpregado: item.codigoDoEmpregado,
    pinParaRegistro: item.pinParaRegistro,
    cpfDoEmpregado: item.cpfDoEmpregado,
    localDeTrabalho: item.localDeTrabalho,
    nomeDaEscala: item.nomeDaEscala,
    nomeDaEscalaDeRetorno: item.nomeDaEscalaDeRetorno,
    possuiFolhaTravada: Boolean(item.possuiFolhaTravada)
  }
}

// O backend não expõe endpoint de detalhe dedicado: o detalhe é o próprio item já
// normalizado. Se receber o shape cru (com `empregado`), normaliza; senão repassa.
export function normalizarDetalheHistorico (item = {}) {
  return item && item.empregado ? normalizarItemHistorico(item) : item
}
